// extracted by mini-css-extract-plugin
module.exports = {"customerHeader":"styles_customerHeader__-BS67"};